import { render, staticRenderFns } from "./LangPairFieldset.vue?vue&type=template&id=41d16c21&scoped=true&"
import script from "./LangPairFieldset.vue?vue&type=script&lang=js&"
export * from "./LangPairFieldset.vue?vue&type=script&lang=js&"
import style0 from "./LangPairFieldset.vue?vue&type=style&index=0&id=41d16c21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d16c21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCardTitle,VCol,VContainer,VDivider,VRow,VTextField})
